// extracted by mini-css-extract-plugin
export default {"slideshow":"Home_slideshow__-6UKg","wrapper":"Home_wrapper__0DjwL","courseItem":"Home_courseItem__wuKE3"};